import React, { useState } from 'react';
import { TextInput, Typography } from '@vp/swan';
import { useUserFeatureContext } from '@vp/core-ui-components';

export const DebugNewFeatureEntry = () => {
  const [newFeatureName, setNewFeatureName] = useState<string>('');
  const { overrideFeatureSettings } = useUserFeatureContext();

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      overrideFeatureSettings({ featureName: newFeatureName });
      setNewFeatureName('');
    }
  };

  const handleTextInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFeatureNameInput = event.currentTarget.value.trim();
    if (newFeatureNameInput !== newFeatureName) {
      setNewFeatureName(newFeatureNameInput);
    }
  };

  return (
    <>
      <Typography fontWeight="bold" fontSize="small" mb={3}>
        Enter New Feature:
      </Typography>
      <TextInput
        placeholder="Enter a new feature to introduce in this session, enabled by default."
        onChange={handleTextInput}
        onKeyPress={handleKeyPress}
        value={newFeatureName}
      />
    </>
  );
};
